@if (!loading() && settings()) {
  <div
    [class.toggle-off]="!value()"
    class="ga-toggle email"
    (click)="toggleValue()"
  >
    @if (!allNotifications()) {
      <label class="body-bold">
        {{ i18n.langString("allow_email") }}
      </label>
    } @else {
      <label class="body-bold">
        {{ i18n.langString("allow_email_notifications") }}
      </label>
    }
    <nz-switch [ngModel]="value()"></nz-switch>
  </div>
}
<span class="email-info-1">{{ i18n.langString("email_will_be_sent_to") }}</span>
<span class="email-info-2">{{ userEmail() }}</span>
